export const components = {
  emptyState: {
    primaryTitle: 'Ups!',
    primaryText: 'Nie ma jeszcze tutaj nic…',
    secondaryTitle: 'Nic do wyświetlenia',
    secondaryText: 'Niestety, nie ma elementów do wyświetlenia na podstawie zastosowanych filtrów…'
  },
  filters: {
    all: 'Wszystko',
    search: 'Szukaj',
    priceRange: 'Zakres cenowy {currency}',
    minValue: 'Minimalna wartość wynosi {val}!',
    maxValue: 'Maksymalna wartość wynosi {val}!',
    reset: 'Resetuj',
    apply: 'Zastosuj'
  },
  comments: {
    reply: 'Odpowiedz',
    loadMore: 'Załaduj więcej',
    edited: 'Edytowane',
    noComments: 'Brak komentarzy',
    leaveFirstComment: 'Możesz zostawić pierwszy'
  },
  curtain: {
    close: 'Zamknij'
  },
  photoPreview: {
    close: 'Zamknij'
  },
  photoCropper: {
    back: 'Wstecz',
    save: 'Zapisz'
  },
  rightSidebar: {
    in: 'w'
  },
  pushPrompt: {
    title: '“{appName}” chciałby/łaby wysyłać Ci powiadomienia',
    description: 'Powiadomienia mogą zawierać alerty, dźwięki i ikony. Można je skonfigurować w Ustawieniach.',
    later: 'Zapytaj mnie później',
    neverLater: 'Nigdy więcej nie pytaj',
    allow: 'Zezwól'
  },
  inAppPush: {
    attachment: 'Załącznik'
  },
  installPrompt: {
    android: {
      install: 'Zainstaluj',
      description: 'Dla płynnego doświadczenia nie musisz używać przeglądarki. Po prostu zainstaluj to jako aplikację.',
      press: 'Naciśnij',
      andSelect: 'i wybierz',
      orSimply: 'lub po prostu',
      description2: 'kliknij przycisk Zainstaluj poniżej',
      notNow: 'Nie teraz'
    },
    ios: {
      justTap: 'Stuknij',
      buttonInBrowser: 'przycisk „Więcej" w przeglądarce i wybierz „Udostępnij"',
      addToHomeScreen: 'Przewiń w dół i stuknij „Dodaj do ekranu głównego", a następnie kliknij „Dodaj"',
      appWillBeInstalled: 'Aplikacja zostanie dodana do ekranu głównego'
    },
    installApp: 'Zainstaluj aplikację',
    useWeb: 'Użyj wersji internetowej'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'Zainstaluj aplikację',
    menu: 'Menu',
    close: 'Zamknij'
  },
  404: {
    whoops: 'Ups!',
    description:
      'Wygląda na to, że strona nie istnieje, lub może nie masz do niej dostępu. Skontaktuj się z właścicielem aplikacji, aby uzyskać więcej informacji.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Zobacz wszystko'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nowe 1:1',
    'details': 'Szczegóły',
    'coverMessage': 'Wiadomość powitalna',
    'location': 'Lokalizacja',
    'duration': 'Czas trwania',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Okno czasowe',
    'sendInvitation': 'Wyślij zaproszenie',
    'success': 'Sukces',
    'invitationSent':
      'Pomyślnie wysłałeś zaproszenie na spotkanie 1:1. Chcesz pozostać na tej stronie, czy przejść do wszystkich zaplanowanych spotkań 1:1?',
    'seeAll': 'Wszystkie spotkania 1:1',
    'stayHere': 'Zostań tutaj'
  },
  networking: {
    level: {
      1: 'Nie gotowy do networkingu. Brak istotnej aktywności lub zaangażowania.',
      2: 'Rzadko aktywny lub brak kluczowych informacji w profilu, co utrudnia nawiązywanie połączeń z innymi.',
      3: 'Profil uzupełniony ze zdjęciem i online, w pełni gotowy do rozpoczęcia networkingu.',
      4: 'Budowanie impetu - zainicjowano co najmniej jedno połączenie w ciągu ostatnich 6 godzin.',
      5: 'Mistrz networkingu - aktywnie odpowiada na zapytania i angażuje się w interakcje z innymi w ciągu ostatnich 6 godzin.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'za',
    Today: 'Dziś',
    today: 'dziś',
    Tomorrow: 'Jutro',
    tomorrow: 'jutro',
    Yesterday: 'Wczoraj',
    yesterday: 'wczoraj',
    startingNow: 'rozpoczyna się teraz'
  },
  daysMonths: {
    months:
      "['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień']",
    monthsShort: "['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru']",
    weekdays: "['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota']",
    weekdaysShort: "['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So']",
    weekdaysMin: "['N', 'P', 'W', 'Ś', 'C', 'P', 'S']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Osiągnij poziom Legendy przynajmniej raz, aktywnie nawiązując kontakty i tworząc wartościowe połączenia.',
    push_description: 'Włącz powiadomienia push, aby być zawsze w gotowości i nigdy nie przegapić okazji.',
    leader_description: 'Dostań się przynajmniej raz do top 10% w tabeli wyników.',
    meetmaster_description: 'Zainicjuj lub odpowiedz na co najmniej jedno zaproszenie do spotkania 1:1 w aplikacji.',
    connector_description: 'Nawiąż przynajmniej trzy połączenia przez aplikację podczas komponentów.'
  }
}
